import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
import {getDetalleDisponibilidadGlobalObjetivoCustom} from '../../../../../services/getDetalleDisponibilidadGlobalObjetivoCustom'

import { api_host, api_auth } from '../../../../../common/globals/constants';
import { forwardRef } from 'react';
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import PortletContent from 'components/PortletContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import moment from 'moment'
import 'moment/locale/es'  
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';
moment.locale('es')


const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

class TableAvailability extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            node: this.props.params.node,
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            dataStep:[],
            periodical:this.props.periodical

        }
  
    }

    static getDerivedStateFromProps(props, state) {
        //console.log('derived','props',props.params.node , 'state',state.node)
        if (props.params.node !== state.node) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                node: props.params.node,
                dataError: false,
                isLoading: true,
                statePeriod: props.params.statePeriod
            }
        }  
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        const {startDate: startDateState, endDate: endDateState} = this.state.statePeriod
        const {startDate: startDateProps, endDate: endDateProps} = prevProps.params.statePeriod
        if (
            (prevProps.params.node !== this.state.node) ||
            (startDateState !== startDateProps || endDateState !== endDateProps)) {
            this.getDataFromAPI();
        }

    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.match.params
        const { period, statePeriod, node, schedule} = this.props.params
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        
        fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
        // fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
        // correccion para que la fecha sea hora local
        fecha_termino = moment(statePeriod.endDate).format().substring(0, 10)
        //console.log(fecha_inicio, fecha_termino)
        getDetalleDisponibilidadGlobalObjetivoCustom(objetivo_id, node, fecha_inicio, fecha_termino, token, schedule).then(data => {
            if (data.status == 1 || data.status == 5) {
                localStorage.setItem('isAuthenticated', false);                        
            } else {
                //Procesa la Data Recibida
                try {
                    //console.log('  va a process')
                    this.processData(data,
                        period,
                        fecha_inicio,
                        fecha_termino)
                } catch (error) {
                    //console.log('error')
                    this.setState({
                        dataError: true,
                        isLoading: false
                    });
                }
            }
            
        })
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,period,fecha_inicio,fecha_termino) => {
        var DataStep=[]
        //console.log(externalData)
        externalData.Objetivo.Paso.forEach((element, forEachKey) => {
            //console.log(element.paso_nombre)
            let eventup = 0
            let down = 0
            let parcial = 0
            let noMon = 0
            let eventCli = 0
            element.estado.forEach(estados=>{
                let dateHasta = (new Date(estados.fecha_hasta))
                let dateDesde = (new Date(estados.fecha_desde))
                let result = dateHasta - dateDesde
                if (estados.nombre === "uptime") {
                    eventup = eventup + result
                } else if (estados.nombre === "downtime") {
                    down = down + result
                } else if (estados.nombre === "no monitoreo") {
                    noMon = noMon + result
                } else if (estados.nombre === "evento cliente" || estados.nombre === 'marcado atentus') {
                    eventCli = eventCli + result
                } else {
                    parcial = parcial + result
                }
            })
            let total = eventup + down + parcial + noMon + eventCli
            eventup = (eventup * 100 / total).toFixed(2)
            down = (down * 100 / total).toFixed(2)
            parcial = (parcial * 100 / total).toFixed(2)
            noMon = (noMon * 100 / total).toFixed(2)
            eventCli = (eventCli * 100 / total).toFixed(2)
            DataStep.push({"paso":element.paso_nombre,"Uptime":eventup, "Dp":parcial,"Downtime":down,"noMon":noMon,"eventCli":eventCli})
        })
        this.setState({
            dataError: false,
            isLoading: false,
            dataStep:DataStep
        });
        //console.log('process=>>',DataStep, this.state.dataError, this.state.isLoading)


    }
    render() {
        const { dataError, isLoading, dataStep, periodical} = this.state;
        var defaultData=0
        if(periodical===true){
            defaultData=null
        }
        //console.log('render=>>> error',dataError, 'load',isLoading,'data', dataStep)
        sessionStorage.setItem("tableAvailability",JSON.stringify(dataStep))
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (dataError===false) {
            if(isLoading===true){
                return (
                    <PortletContent>
                        <PerfectScrollbar>

                            <Typography
                            variant="h5"
                            >
                            <CircularProgress
                            variant="indeterminate"

                            size={24}
                            thickness={4}
                            
                            />
                            <br/>
                            {t('text.loading')}
                        </Typography>
                        </PerfectScrollbar>
                    </PortletContent>
                )
            }else{
                return(
                    <MaterialTable
                        icons={tableIcons}
                        columns={[
                            { title: t('table-availability.mui-table.columns.title.step'), field: "paso",defaultGroupOrder: {defaultData} },
                            { title: t('table-availability.mui-table.columns.title.uptime'), field: "Uptime"/*, type: "numeric"*/ },
                            { title: t('table-availability.mui-table.columns.title.partial'), field: "Dp"/*, type: "numeric"*/},
                            { title: t('table-availability.mui-table.columns.title.downtime'), field: "Downtime"/*, type: "numeric"*/},
                            { title: t('table-availability.mui-table.columns.title.no-monitoring'), field: "noMon"/*, type: "numeric"*/ },
                            { title: t('table-availability.mui-table.columns.title.client-event'), field: "eventCli"/*, type: "numeric"*/ },
                        ]}
                        data={dataStep}
                        title=""
                        localization={t('table-availability.mui-table.localization', { returnObjects: true })}
                        options={{
                            grouping: true
                        }}
                    />                    
                )
            }
        }
        else if (dataError===true) {
            return (<p>{t('text.no-data')}</p>)
        }
        else return (<p> Error!</p >)

    }
}


export default compose(withRouter, withTranslation())(TableAvailability);